var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonBackToTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 48.004 48.002"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15206"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2509",
  d: "M24.004 0a24 24 0 11-24 24 24 24 0 0124-24z",
  fill: "#fff",
  opacity: 0.75
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Union 66",
  d: "M14.648 46.111A23.926 23.926 0 011.894 33.365a24.1 24.1 0 01-.006-18.719A23.98 23.98 0 0114.636 1.888a24.135 24.135 0 0118.719 0 23.985 23.985 0 0112.758 12.746 24.135 24.135 0 010 18.719 23.962 23.962 0 01-12.748 12.758 24.107 24.107 0 01-18.717 0zM8.867 8.865a21.575 21.575 0 1015.135-6.2 20.6 20.6 0 00-15.135 6.2zm14.184 23.279a1.282 1.282 0 01-.389-.943V20.566l-4.385 4.385a1.282 1.282 0 01-.945.395 1.329 1.329 0 01-.949-.406 1.373 1.373 0 01-.383-.951 1.286 1.286 0 01.4-.943l6.65-6.652a1.294 1.294 0 01.441-.3 1.417 1.417 0 01.5-.1 1.449 1.449 0 01.51.1 1.387 1.387 0 01.439.3l6.664 6.664a1.278 1.278 0 01.395.938 1.315 1.315 0 01-.395.945 1.335 1.335 0 01-1.906 0l-4.373-4.373v10.635a1.335 1.335 0 01-2.279.943z",
  fill: "#f96506"
})));
export default __webpack_public_path__ + "static/button-back-to-top.c2fa165770c52cd11bd722a0e9a0490f.svg";
export { SvgButtonBackToTop as ReactComponent };